(() => {
  const button = document.querySelector('.gg-works-menu-button');
  const drawer = document.getElementById('GoodGameMenuDrawer');
  if (!button || !drawer) return;
  // The existing headerInit owns opening and closing; expose its state to AT.
  const update = () => {
    const open = drawer.classList.contains('open');
    button.setAttribute('aria-expanded', String(open));
    button.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
  };
  new MutationObserver(update).observe(drawer, {attributes:true, attributeFilter:['class']});
  document.addEventListener('keydown', event => {
    if (!drawer.classList.contains('open')) return;
    if (event.key === 'Escape') {
      button.click();
      button.focus();
    }
  });
  update();
})();
